import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT_E_COMMERCE } from './route-names'

/**
 * Freenet desktop flow routes (nested under CheckoutFlow with header)
 * These should be imported in e-commerce routes with relative paths
 */
export const freenetFlowRoutes: RouteRecordRaw[] = [
  {
    path: 'services/freenet',
    name: CHECKOUT_E_COMMERCE.SERVICES.FREENET.ROOT,
    redirect: { name: CHECKOUT_E_COMMERCE.SERVICES.FREENET.PHONELINE_SETUP },
    meta: {
      owners: ['bot-squad-partnerships-front'],
      auth: {
        mode: ['authenticated'],
        redirection: {
          default: {
            name: ROUTES.AUTH.LOGIN,
            query: { bm_journey: 'checkout' },
          },
        },
      },
      tracking: { contentGroup: 'Services Checkout' },
    },
  },
  {
    path: 'services/freenet/phoneline-setup',
    name: CHECKOUT_E_COMMERCE.SERVICES.FREENET.PHONELINE_SETUP,
    component: () =>
      import('~/scopes/checkout/flows/e-commerce/pages/FreenetPhonelineSetup/FreenetPhonelineSetup.vue'),
    meta: {
      owners: ['bot-squad-partnerships-front'],
      auth: {
        mode: ['authenticated'],
        redirection: {
          default: {
            name: ROUTES.AUTH.LOGIN,
            query: { bm_journey: 'checkout' },
          },
        },
      },
      tracking: { contentGroup: 'Services Checkout' },
    },
  },
]
